import { SYMBOL_FONTS } from '@/constants';
export default [
    {
        labelKey: 'pxc_symb-additional',
        labelDefault: "Additional",
        name: 'PxC_Symb-Additional',
        unicodeRange: '0xF021-0xF03B',
    },
    {
        labelKey: 'pxc_symb-certification',
        labelDefault: "Certification",
        name: 'PxC_Symb-Certification',
        unicodeRange: '0xF021-0xF081',
    },
    {
        labelKey: 'pxc_symb-datacommunication',
        labelDefault: "Datacommunication",
        name: 'PxC_Symb-Datacommunication',
        unicodeRange: '0xF021-0xF023',
    },
    {
        labelKey: 'pxc_symb-electrical',
        labelDefault: "Electrical",
        name: 'PxC_Symb-Electrical',
        unicodeRange: '0xF021-0xF056',
    },
    {
        labelKey: 'pxc_symb-geometric',
        labelDefault: "Geometric",
        name: 'PxC_Symb-Geometric',
        unicodeRange: '0xF021-0xF026',
    },
    {
        labelKey: 'pxc_symb-ghs',
        labelDefault: "GHS",
        name: SYMBOL_FONTS.GHS,
        unicodeRange: '0xF021-0xF02A',
    },
    {
        labelKey: 'pxc_symb-logo',
        labelDefault: "Logo",
        name: 'PxC_Symb-Logo',
        unicodeRange: '0xF021-0xF026',
    },
    {
        labelKey: 'pxc_symb-mandatory',
        labelDefault: "Mandatory",
        name: SYMBOL_FONTS.MANDATORY,
        unicodeRange: '0xF021-0xF041',
    },
    {
        labelKey: 'pxc_symb-miscellaneous',
        labelDefault: "Miscellaneous",
        name: 'PxC_Symb-Miscellaneous',
        unicodeRange: '0xF021-0xF021',
    },
    {
        labelKey: 'pxc_symb-prohibition',
        labelDefault: "Prohibition",
        name: SYMBOL_FONTS.PROHIBITION,
        unicodeRange: '0xF021-0xF04A',
    },
    {
        labelKey: 'pxc_symb-transport',
        labelDefault: "Transport",
        name: 'PxC_Symb-Transport',
        unicodeRange: '0xF021-0xF021',
    },
    {
        labelKey: 'pxc_symb-warning',
        labelDefault: "Warning",
        name: SYMBOL_FONTS.WARNING,
        unicodeRange: '0xF021-0xF06B',
    },
    {
        labelKey: 'pxc_symb-inspection',
        labelDefault: "Inspection",
        name: 'PxC_Symb-Inspection',
        unicodeRange: '0xF030-0xF03C',
    }
];
